<template>
  <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer"
    :mini-variant="miniNav" app enable-resize-watcher persistent stateless
    class="primary">
    <template v-slot:prepend>
      <!-- Your burger icon or any other custom content goes here -->
      <v-btn icon @click="miniNav = !miniNav">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-tile avatar>
        <v-list-tile-avatar @click="miniNav = !miniNav">
          <img v-if="showIcon" src="../../assets/avatar/solarIcon.svg"
            alt="Solar">
          <img v-else src="../../assets/avatar/user.svg" alt="User">
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{name}}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon @click.native.stop="miniNav = !miniNav">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider class="mt-1"></v-divider>
      <template v-for="(item, index) in items">
        <v-divider v-if="item.divider" :key="'A' + index"></v-divider>
        <v-tooltip color="bg" right v-else v-show="item.verify ? item.verify(getUserInfo('role')) : true" :key="'B' + index">
          <template v-slot:activator="{ on }">
            <v-list-tile v-on="on" :key="item.text" v-on:click="navSelectionHandler(item.component)">
              <v-list-tile-action>
                <img
                  :class="active[componentRoute(item.component)] ? 'active-nav': 'menu-icons'"
                  :src="require(`./../../assets/navigation/${item.icon}.svg`)" 
                  :alt="item.icon"
                  width="20"
                />
              </v-list-tile-action>
              <v-list-tile-content>
              <v-list-tile-title>{{ $t(item.text) }}</v-list-tile-title>
            </v-list-tile-content>
            </v-list-tile>
          </template>
          <span class="tooltip-text__color">{{ $t(item.text) }}</span>
        </v-tooltip>
      </template> 

      <v-list-tile-avatar v-if="miniNav">
        <img v-show="isDark" src="./../../assets/logo/enerman-etisol_new_dark.svg">
        <img v-show="!isDark" src="./../../assets/logo/enerman-etisol_new_light.svg">
      </v-list-tile-avatar>
      <v-list-tile-avatar v-if="miniNav">
        <span class="version-text caption">v {{version}}</span>
      </v-list-tile-avatar>
      <v-list-tile v-if="miniNav" class="last-update-title">
        <div>
          <span class="version-text">{{ $t('Last Update') }}: {{ lastUpdateTime }}</span>
        </div>
      </v-list-tile>

      <v-list-tile-content class="logo-title">
        <div class="layout column align-center">
          <img v-show="isDark" src="./../../assets/logo/enerman-etisol_new_dark.svg" width="180px" height="75px">
          <img v-show="!isDark" src="./../../assets/logo/enerman-etisol_new_light.svg" width="180px" height="75px">
          <span class="version-text caption mt-2">v {{version}}</span>
        </div>
      </v-list-tile-content>
      <v-list-tile-content>
        <div>
          <span class="version-text last-update-title">{{ $t('Last Update') }}: {{ lastUpdateTime }}</span>
        </div>
      </v-list-tile-content>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from 'vuex'
import moment from 'moment'
import menuList from '@/services/menu.js'
import {
  version
} from '../../../../package.json'

export default {
  props: {
    name: String
  },
  data() {
    return {
      version,
      drawer: true,
      items: [],
      active: {},
      currentWidth: 0,
      currentTab: ''
    }
  },
  created() {
    if (this.getGeneralState('showHomeDB')) {
      this.items = menuList.items
    } else {
      this.items = menuList.menuItems
    }
  },
  onResize(event) {
    this.currentWidth = window.innerWidth
    if (this.$vuetify.breakpoint.xs) {
      this.items = menuList.mobileItems
    } else if (this.$vuetify.breakpoint.mdAndUp) {
      this.items = menuList.items
    }
  },
  mounted() {
    // this.miniNav = this.mini
    this.$set(this.active, this.extractPath(this.$route), true)
  },
  computed: {
    ...mapGetters([
      'getUserInfo',
      'getRules',
      'getGeneralState'
    ]),
    isDark() {
      return this.getGeneralState('theme_dark')
    },
    lastUpdateTime() {
      return moment(this.getGeneralState('lastCallTime')).format('H:mm:ss')
    },
    showIcon() {
      return this.getUserInfo('email') === 'abijitsolar@enerman.in'
    },
    widthBoolean() {
      return this.currentWidth < 960
    },
    miniNav: {
      get() {
        return this.getGeneralState('miniNav')
      },
      set(value) {
        this.SET_MINI_NAV(value)
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_SELECTED_COMPONENT_MENU',
      'SET_MINI_NAV'
    ]),
    extractPath(routerObj) {
      if (routerObj.path === '/') {
        return '/home'
      }
      return routerObj.path
    },
    navSelectionHandler(component) {
      this.currentTab = component
      switch (component) {
        case 'home':
        case 'plantOverview':
        case 'devices':
        case 'alert':
        case 'more':
        case 'admin':
          this.$router.push(this.componentRoute(component))
          break
        case 'support':
          this.supportSite()
          break
        case 'logout':
          this.$emit('logout')
          break
      }
    },
    supportSite: function () {
      window.open('https://support.enerman.in/portal/en/signin')
    },
    componentRoute(param) {
      try {
        if (param == 'admin' && this.getUserInfo('role') == 'super-admin') {
          return '/ics-admin'
        } else if (this.getRules('rule')) {
          if (this.getRules(['rule', 'access_config', `${param}`])) {
            if (this.getRules(['rule', 'access_config', `${param}`, 'path'])) {
              return this.getRules(['rule', 'access_config', `${param}`, 'path'])
            }
            return `/general/${param}`
          }
          return null
        } else {
          return '/'
        }
      } catch (err) {
        return '/'
      }
    }
  },
  watch: {
    currentTab() {
      this.SET_SELECTED_COMPONENT_MENU(this.currentTab)
    },
    mini() {
      this.miniNav = this.mini
    },
    $route(to, from) {
      this.$set(this.active, this.extractPath(from), false)
      this.$set(this.active, this.extractPath(to), true)
    }
  }
}
</script>

<style>
.theme--light .tooltip-text__color {
  color: #000;
}

.active-nav {
  filter: invert(52%) sepia(92%) saturate(392%) hue-rotate(354deg) brightness(102%) contrast(92%);
}

.theme--light .menu-icons {
  filter: invert(48%) sepia(12%) saturate(463%) hue-rotate(179deg) brightness(98%) contrast(86%);
}

.theme--dark .version-text {
  color: #fff !important;
}

.theme--light .version-text {
  color: #535c72 !important;
}

.logo-title {
  flex-direction: row;
}

.last-update-title {
  position: absolute;
  bottom: 10%;
  width: 100%;
  text-align: center;
  margin-bottom: 25px;
}

</style>
